/**
 * Renders a view a tool asked the assistant to show (an `AgentUiAction` of
 * type `"view"`), by looking up `view.component` in the registry
 * (`agentViewComponentFor`). An unregistered component — an inherited Object
 * member such as `constructor` included — renders nothing rather than
 * failing the message: a package that has not shipped its view yet must not
 * break an older answer that still names it.
 */
import type { AgentViewComponentProps } from "./registry.js";
import { agentViewComponentFor } from "./registry.js";

export function AgentViewCard({
  view,
  onSend,
  busy,
  answeredWith,
}: AgentViewComponentProps) {
  const Component = agentViewComponentFor(view.component);
  if (!Component) return null;
  return (
    <Component
      view={view}
      onSend={onSend}
      busy={busy}
      answeredWith={answeredWith}
    />
  );
}
